import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';

@Injectable()
export class RoleService {
	private _role: string = '';

	constructor(private ls: LocalStorageService) {
		this._role = this.ls.getItem('role');
	}
	
	get role(){
		return this._role;
	}
}